// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-sync-setup {
  min-height: calc(100vh - 140px);
  padding: 40px;
  background: #f8fafc;
}

.review-header {
  text-align: center;
  margin-bottom: 40px;
}

.review-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.review-header p {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 8px;
}

.review-sections {
  max-width: 800px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.review-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e5e7eb;
}

.review-section h2 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
}

.connector-display {
  display: flex;
  align-items: center;
  gap: 16px;
}

.platform-logo img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.connector-arrow {
  color: #6b7280;
}

.direction-value {
  font-size: 16px;
  color: #1f2937;
  font-weight: 500;
}

.mapping-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.view-details-btn {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.mapping-table {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.mapping-headers {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  background: #f9fafb;
  padding: 12px 16px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.mapping-rows {
  display: flex;
  flex-direction: column;
}

.mapping-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  padding: 12px 16px;
  border-top: 1px solid #f3f4f6;
  align-items: center;
}

.field-left,
.field-right {
  font-size: 14px;
  color: #1f2937;
}

.mapping-arrow {
  color: #6b7280;
  display: flex;
  justify-content: center;
}

.warning-section {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 12px;
  max-width: 800px;
  margin: 0 auto 40px;
}

.warning-icon {
  color: #f59e0b;
  flex-shrink: 0;
}

.warning-content p {
  font-size: 14px;
  color: #92400e;
  margin-bottom: 8px;
}

.warning-content p:last-child {
  margin-bottom: 0;
}

.actions-section {
  display: flex;
  justify-content: center;
  gap: 16px;
  max-width: 800px;
  margin: 0 auto;
}

.back-button,
.start-syncing-button {
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.back-button:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.start-syncing-button {
  background: #10b981;
  color: white;
  border: 1px solid #10b981;
}

.start-syncing-button:hover {
  background: #059669;
  border-color: #059669;
}

@media (max-width: 768px) {
  .review-sync-setup {
    padding: 20px;
  }

  .mapping-headers,
  .mapping-row {
    grid-template-columns: 1fr auto 1fr;
    gap: 8px;
  }

  .actions-section {
    flex-direction: column;
  }

  .back-button,
  .start-syncing-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/components/ReviewSyncSetup.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,mCAAmC;IACnC,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".review-sync-setup {\n  min-height: calc(100vh - 140px);\n  padding: 40px;\n  background: #f8fafc;\n}\n\n.review-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.review-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 12px;\n}\n\n.review-header p {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 8px;\n}\n\n.review-sections {\n  max-width: 800px;\n  margin: 0 auto 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.review-section {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  border: 1px solid #e5e7eb;\n}\n\n.review-section h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 16px;\n}\n\n.connector-display {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.platform-logo img {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n\n.connector-arrow {\n  color: #6b7280;\n}\n\n.direction-value {\n  font-size: 16px;\n  color: #1f2937;\n  font-weight: 500;\n}\n\n.mapping-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.view-details-btn {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.mapping-table {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.mapping-headers {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  background: #f9fafb;\n  padding: 12px 16px;\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.mapping-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n.mapping-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  padding: 12px 16px;\n  border-top: 1px solid #f3f4f6;\n  align-items: center;\n}\n\n.field-left,\n.field-right {\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.mapping-arrow {\n  color: #6b7280;\n  display: flex;\n  justify-content: center;\n}\n\n.warning-section {\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  gap: 12px;\n  max-width: 800px;\n  margin: 0 auto 40px;\n}\n\n.warning-icon {\n  color: #f59e0b;\n  flex-shrink: 0;\n}\n\n.warning-content p {\n  font-size: 14px;\n  color: #92400e;\n  margin-bottom: 8px;\n}\n\n.warning-content p:last-child {\n  margin-bottom: 0;\n}\n\n.actions-section {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.back-button,\n.start-syncing-button {\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button {\n  background: white;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n}\n\n.back-button:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.start-syncing-button {\n  background: #10b981;\n  color: white;\n  border: 1px solid #10b981;\n}\n\n.start-syncing-button:hover {\n  background: #059669;\n  border-color: #059669;\n}\n\n@media (max-width: 768px) {\n  .review-sync-setup {\n    padding: 20px;\n  }\n\n  .mapping-headers,\n  .mapping-row {\n    grid-template-columns: 1fr auto 1fr;\n    gap: 8px;\n  }\n\n  .actions-section {\n    flex-direction: column;\n  }\n\n  .back-button,\n  .start-syncing-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
